export const searchOnArray = (
    items: any,
    search: string | null,
) =>
    search && search !== ''
        ? items.filter(
              (item: any) =>
                  item?.identifier?.toLowerCase().includes(search?.toLowerCase()) ||
                  item?.value?.toLowerCase().includes(search?.toLowerCase()) 
          )
        : [...items];



const sortByCreatedModifiedBy = (
    items: any,
    order: 'asc' | 'desc',
    order_by: string
) => {
    const direction = order === 'asc' ? 1 : -1;
    return items.sort((a: any, b: any) =>
        a?.[order_by]?.username != b?.[order_by]?.username
            ? a?.[order_by]?.username > b?.[order_by]?.username
                ? direction
                : -direction
            : 0
    );
};


export const sortArray = (
    items: any,
    order: 'asc' | 'desc',
    order_by: string,
) => {
    const direction = order === 'asc' ? 1 : -1;
    return  items.sort((a: any, b: any) =>
                  !a[order_by] && order==='asc' ?direction:
                  !a[order_by] && order!=='asc' ? -direction:
                  !b[order_by] && order==='asc'? -direction:
                  !b[order_by] && order!=='asc'? direction
                  : a[order_by] == b[order_by]
                  ? 0
                  : a[order_by] > b[order_by]
                  ? direction
                  : -direction
          );
};
